// Texto del "Contrato de Novación de Obligación Crediticia" de Inversiones Osviel S.A.S.,
// transcrito de la plantilla en Word que usa el área jurídica.
//
// Es texto legal: no reescribir sin autorización del área responsable. Lo único que
// cambia por crédito son los datos que se interpolan desde buildContratoData.

import montoEnLetras from './montoEnLetras';

export const TITULO = 'CONTRATO DE NOVACIÓN DE OBLIGACIÓN CREDITICIA';

// Datos del acreedor. Van fijos, como el NIT en los demás formatos impresos.
export const ACREEDOR = {
    razonSocial: 'INVERSIONES OSVIEL S.A.S.',
    nit: '900.344.946-3',
    ciudad: 'Maicao',
    departamento: 'La Guajira',
    representante: 'OSCAR EDUARDO MENDOZA OLMOS',
    cedulaRepresentante: '9.147.684',
    lugarExpedicionRepresentante: 'Cartagena (Bolívar)',
    cargoRepresentante: 'Representante Legal'
};

const comparecencia = ({ deudor }) => (
    `Entre los suscritos, a saber: de una parte, ${ACREEDOR.razonSocial}, sociedad comercial de ` +
    `derecho privado, identificada con NIT ${ACREEDOR.nit}, con domicilio principal en la ciudad de ` +
    `${ACREEDOR.ciudad} (${ACREEDOR.departamento}), representada legalmente por el señor ` +
    `${ACREEDOR.representante}, mayor de edad, identificado con cédula de ciudadanía No. ` +
    `${ACREEDOR.cedulaRepresentante} expedida en ${ACREEDOR.lugarExpedicionRepresentante}, quien obra ` +
    `en calidad de ${ACREEDOR.cargoRepresentante} y quien en adelante se denominará EL ACREEDOR; y de ` +
    `la otra parte, el (la) señor(a) ${deudor.nombre}, mayor de edad, identificado(a) con ` +
    `${deudor.tipoDocumento} No. ${deudor.identificacion} expedida en ${deudor.lugarExpedicion}, ` +
    `domiciliado(a) en la ciudad de ${deudor.ciudad}, con dirección de notificación ` +
    `${deudor.direccion} y correo electrónico ${deudor.email}, quien en adelante se denominará ` +
    `EL DEUDOR, se celebra el presente Contrato de Novación de Obligación Crediticia, el cual se ` +
    `regirá por los artículos 1687 y siguientes del Código Civil, las disposiciones pertinentes del ` +
    `Código de Comercio, la Ley 1527 de 2012, la Ley 1902 de 2018, la Ley 1266 de 2008, la Ley 1581 ` +
    `de 2012 y demás normas aplicables, previas las siguientes cláusulas:`
);

// Una línea por obligación novada. Las de terceros se identifican con su titular:
// la novación puede cancelar créditos que no están a nombre del deudor.
const descripcionObligacion = (obligacion) => (
    `Obligación identificada con el número ${obligacion.numero} otorgado el día ` +
    `${obligacion.fechaOtorgamiento}, cuyo capital original fue de ${obligacion.capitalOriginal}` +
    `${obligacion.titular ? `, a cargo de ${obligacion.titular}` : ''}, y cuyo saldo insoluto a la ` +
    `fecha de suscripción del presente contrato asciende a la suma de ` +
    `${montoEnLetras(obligacion.saldoValor)} (${obligacion.saldo}), suma que incluye capital, ` +
    `intereses remuneratorios causados y demás conceptos a cargo del deudor.`
);

export const construirClausulas = ({ deudor, credito, obligaciones }) => {
    const nuevoCredito = `${montoEnLetras(credito.montoValor)} (${credito.monto})`;
    const numerosObligaciones = obligaciones.map(o => o.numero).join(', ');

    return [
        {
            titulo: 'PRIMERA. ANTECEDENTES Y RECONOCIMIENTO DE LA(S) OBLIGACIÓN(ES) ORIGINAL(ES).',
            parrafos: [
                'EL DEUDOR reconoce expresa, libre y voluntariamente que es titular de la(s) obligación(es) ' +
                'crediticia(s) descrita(s) a continuación a favor de EL ACREEDOR,',
                ...obligaciones.map(descripcionObligacion),
                `En virtud de lo anterior, EL DEUDOR manifiesta que ha solicitado a EL ACREEDOR el ` +
                `otorgamiento de un nuevo crédito por valor de ${nuevoCredito}, con el fin de cancelar y ` +
                `sustituir las obligaciones anteriormente relacionadas. EL ACREEDOR acepta dicha solicitud, ` +
                `razón por la cual las partes acuerdan que el nuevo crédito será destinado al pago total de ` +
                `las obligaciones originales y que, por efecto de la presente novación, éstas quedarán ` +
                `extinguidas y sustituidas por la nueva obligación en los términos y condiciones ` +
                `establecidos en el presente contrato.`
            ]
        },
        {
            titulo: 'SEGUNDA. OBJETO.',
            parrafos: [
                `El presente contrato tiene por objeto instrumentar la novación de la(s) obligación(es) ` +
                `crediticia(s) descrita(s) en la cláusula primera, mediante el otorgamiento por parte de ` +
                `EL ACREEDOR de un nuevo crédito a favor de EL DEUDOR por valor de ${nuevoCredito}, cuyos ` +
                `recursos se destinan a cancelar las obligaciones originales. En consecuencia, dichas ` +
                `obligaciones se extinguen y son sustituidas por la nueva obligación de carácter dinerario ` +
                `contenida en el presente contrato, con los términos, plazos, condiciones de pago y ` +
                `garantías aquí pactados, de conformidad con lo dispuesto en los artículos 1687 y ` +
                `siguientes del Código Civil colombiano.`
            ]
        },
        {
            titulo: 'TERCERA. ANIMUS NOVANDI Y EXTINCIÓN DE LA OBLIGACIÓN ANTERIOR.',
            parrafos: [
                'Las partes manifiestan de manera libre, expresa, consciente e inequívoca su voluntad de ' +
                'extinguir la(s) obligación(es) anteriormente descrita(s) y sustituirla por una nueva ' +
                'obligación, configurándose plenamente la novación. En consecuencia, a partir de la ' +
                'suscripción del presente contrato, la(s) obligación(es) original(es) quedará(n) ' +
                'extinguida(s) de pleno derecho y será(n) reemplazada(s) íntegramente por la nueva ' +
                'obligación aquí contenida, sin que ello constituya, en ningún caso, remisión, condonación, ' +
                'dación en pago, novación por cambio de deudor o renuncia al derecho de crédito de ' +
                'EL ACREEDOR. La(s) extinción(es) de la(s) obligación(es) original(es) no afecta(n) las ' +
                'garantías reales o personales que se hubieren constituido, las cuales, en lo pertinente, ' +
                'se entienden extendidas y ratificadas para respaldar la nueva obligación.'
            ]
        },
        {
            titulo: 'CUARTA. NUEVA OBLIGACIÓN Y CONDICIONES DE PAGO.',
            parrafos: [
                `Como consecuencia del otorgamiento del nuevo crédito y de la novación pactada entre las ` +
                `partes, EL DEUDOR reconoce adeudar a favor de EL ACREEDOR, de manera clara, expresa y ` +
                `exigible, la suma de ${nuevoCredito}, correspondiente al valor del nuevo crédito que ` +
                `sustituye íntegramente la obligación identificada con el número ${numerosObligaciones}, ` +
                `la cual se pagará bajo las siguientes condiciones:`
            ],
            items: [
                `a) Monto transado (capital): ${credito.monto}`,
                `b) Número de cuotas: ${credito.cuotas}`,
                `c) Valor de cada cuota: ${credito.valorCuota}`,
                `d) Periodicidad de pago: ${credito.periodicidad}`,
                `e) Fecha del primer vencimiento: ${credito.primerVencimiento}.`
            ],
            cierre: [
                'La nueva obligación causará intereses remuneratorios y, en caso de mora, intereses ' +
                'moratorios a la tasa máxima legal vigente, sin que en ningún caso se excedan los límites ' +
                'establecidos por la ley. El no pago oportuno de cualquiera de las cuotas generará ' +
                'automáticamente la mora, sin necesidad de requerimiento previo.'
            ]
        },
        {
            titulo: 'QUINTA. GARANTÍAS.',
            parrafos: [
                'La nueva obligación estará respaldada por las siguientes garantías: pagaré a la orden, ' +
                'carta de instrucciones, letra de cambio, codeudor(es) solidario(s), hipoteca, prenda u ' +
                'otras. En caso de suscribirse pagaré, carta de instrucciones o cualquier otra garantía ' +
                'personal o real, estos instrumentos garantizarán de manera expresa el cumplimiento de la ' +
                'obligación surgida con ocasión de la presente novación, incluyendo capital, intereses, ' +
                'costas, honorarios y demás conceptos derivados del incumplimiento. EL DEUDOR y, en su ' +
                'caso, el(los) codeudor(es) solidario(s), se obligan a suscribir y entregar a EL ACREEDOR, ' +
                'en el acto de firma del presente contrato, el(los) título(s) valor(es) y documentos de ' +
                'garantía que se requieran.'
            ]
        },
        {
            titulo: 'SEXTA. LIBRANZA O DESCUENTO DIRECTO.',
            parrafos: [
                'Cuando el pago de la nueva obligación se realice mediante libranza o descuento directo de ' +
                'nómina, EL DEUDOR ratifica de manera irrevocable la autorización previamente otorgada o, ' +
                'en su defecto, autoriza expresa, irrevocable e incondicionalmente a EL ACREEDOR para ' +
                'gestionar la expedición, renovación o actualización de la correspondiente orden de ' +
                'libranza ante la entidad pagadora, de conformidad con la Ley 1527 de 2012 y la Ley 1902 ' +
                'de 2018. EL DEUDOR se obliga a mantener vigente la relación laboral o fuente de ingreso ' +
                'que permite el descuento, a no solicitar la suspensión o cancelación de la libranza sin ' +
                'el consentimiento previo y escrito de EL ACREEDOR, y a informar de inmediato cualquier ' +
                'novedad que afecte el descuento. En caso de pérdida, suspensión, terminación o ineficacia ' +
                'del mecanismo de libranza por cualquier causa, EL DEUDOR continuará obligado al pago de ' +
                'la totalidad de la obligación mediante pago directo en la cuenta que EL ACREEDOR le ' +
                'indique, dentro de los cinco (5) días hábiles siguientes a la notificación de la novedad, ' +
                'sin que ello extinga, modifique o suspenda las obligaciones asumidas en el presente ' +
                'contrato. El incumplimiento de esta obligación constituirá causal de aceleración del plazo.'
            ]
        },
        {
            titulo: 'SÉPTIMA. INCUMPLIMIENTO Y ACELERACIÓN DEL PLAZO.',
            parrafos: [
                'La mora en el pago de cualquiera de las cuotas, el incumplimiento de cualquiera de las ' +
                'obligaciones pactadas en el presente contrato, la pérdida o disminución de las garantías, ' +
                'la falsedad o inexactitud en la información suministrada por EL DEUDOR, o la terminación ' +
                'del mecanismo de libranza sin pago alternativo oportuno, facultará a EL ACREEDOR para ' +
                'declarar vencido anticipadamente el plazo de la obligación y exigir el pago inmediato del ' +
                'saldo insoluto de capital, más los intereses remuneratorios y moratorios causados, costas ' +
                'procesales, honorarios de abogado y demás conceptos legalmente procedentes, sin necesidad ' +
                'de requerimiento judicial o extrajudicial previo.'
            ]
        },
        {
            titulo: 'OCTAVA. AUTORIZACIONES DE TRATAMIENTO DE DATOS Y REPORTE A CENTRALES DE RIESGO.',
            parrafos: [
                'EL DEUDOR autoriza de manera expresa, previa, informada e inequívoca a EL ACREEDOR para ' +
                'efectuar el tratamiento de sus datos personales conforme a la Ley 1581 de 2012 y sus ' +
                'decretos reglamentarios, y, cuando haya lugar, para consultar, reportar, actualizar y ' +
                'rectificar la información relacionada con la presente obligación en las centrales de ' +
                'información crediticia (CIFIN, DataCrédito, TransUnion u otras), de conformidad con la ' +
                'Ley 1266 de 2008 y las normas que la modifiquen, adicionen o sustituyan. Esta ' +
                'autorización se extiende a los codeudores solidarios, si los hubiere.'
            ]
        },
        {
            titulo: 'NOVENA. CESIÓN DEL CRÉDITO.',
            parrafos: [
                'EL ACREEDOR podrá ceder total o parcialmente el presente crédito y los derechos derivados ' +
                'del mismo, incluyendo las garantías, a cualquier tercero, sin necesidad de autorización ' +
                'previa de EL DEUDOR, bastando para su eficacia la notificación de la cesión conforme a la ' +
                'ley. EL DEUDOR se obliga a reconocer al cesionario como nuevo acreedor y a cumplir las ' +
                'obligaciones frente a éste en los mismos términos aquí pactados.'
            ]
        },
        {
            titulo: 'DÉCIMA. NOTIFICACIONES.',
            parrafos: [
                'Las partes aceptan que las notificaciones, requerimientos y comunicaciones relacionadas ' +
                'con el presente contrato se realicen por correo electrónico a las direcciones indicadas ' +
                'en la comparecencia, de conformidad con la Ley 2213 de 2022 y el Código General del Proceso.'
            ]
        },
        {
            titulo: 'DÉCIMA PRIMERA. MÉRITO EJECUTIVO Y CONFESIÓN DE DEUDA.',
            parrafos: [
                'El presente contrato, una vez suscrito por las partes, constituye título ejecutivo ' +
                'completo y suficiente en los términos del artículo 422 del Código General del Proceso, ' +
                'por contener una obligación clara, expresa y exigible a cargo de EL DEUDOR. EL DEUDOR ' +
                'confiesa de manera expresa la existencia y el monto de la obligación aquí contenida. En ' +
                'caso de que se otorgue pagaré u otro título valor, éste prestará mérito ejecutivo de ' +
                'manera independiente o conjunta con el presente contrato. Las partes acuerdan que la ' +
                'simple exhibición del presente documento y/o del título valor correspondiente será ' +
                'suficiente para iniciar el proceso ejecutivo correspondiente.'
            ]
        },
        {
            titulo: 'DÉCIMA SEGUNDA. PERFECCIONAMIENTO E INTEGRIDAD.',
            parrafos: [
                'El presente contrato se perfecciona con la firma de las partes y constituye el acuerdo ' +
                'íntegro y exclusivo entre ellas respecto de la novación aquí regulada, dejando sin efecto ' +
                'cualquier estipulación anterior contraria. Cualquier modificación deberá constar por ' +
                'escrito y ser suscrita por ambas partes. La invalidez o ineficacia de alguna cláusula no ' +
                'afectará la validez del resto del contrato.'
            ]
        }
    ];
};

export const construirCierre = ({ firma }) => (
    `En constancia de lo anterior, se firma el presente contrato en la ciudad de ${ACREEDOR.ciudad} a ` +
    `los ${firma.dia} días del mes de ${firma.mes} de ${firma.anio}, en dos (2) ejemplares del mismo ` +
    `tenor y valor, uno para cada parte.`
);

export { comparecencia as construirComparecencia };
